import { useHistory, useLocation } from 'react-router-dom';
import { useCallback, useMemo } from 'react';
import { SearchEntityType } from 'src/components/search/constants';

export interface SearchParams {
  query: string;
  entityType: SearchEntityType;
  filters: { [key: string]: string[] };
}

export const useSearchParams = () => {
  const location = useLocation();
  const history = useHistory();

  const params = useMemo((): SearchParams => {
    const urlParams = new URLSearchParams(location.search);
    const query = urlParams.get('query') || '';
    const entityType = (urlParams.get('type') as SearchEntityType) || SearchEntityType.Dataset;
    let filters: { [key: string]: string[] } = {};
    try {
      const filtersParam = urlParams.get('filters');
      if (filtersParam) {
        filters = JSON.parse(filtersParam);
      }
    } catch (e) {
      // Invalid JSON, use empty filters
    }
    return { query, entityType, filters };
  }, [location.search]);

  const setParams = useCallback(
    (newParams: Partial<SearchParams>) => {
      const urlParams = new URLSearchParams(location.search);

      if (newParams.query !== undefined) {
        if (newParams.query) {
          urlParams.set('query', newParams.query);
        } else {
          urlParams.delete('query');
        }
      }

      if (newParams.entityType !== undefined) {
        urlParams.set('type', newParams.entityType);
      }

      if (newParams.filters !== undefined) {
        if (Object.keys(newParams.filters).length > 0) {
          urlParams.set('filters', JSON.stringify(newParams.filters));
        } else {
          urlParams.delete('filters');
        }
      }

      history.push({ pathname: location.pathname, search: urlParams.toString() });
    },
    [history, location.pathname, location.search],
  );

  return { params, setParams };
};
